export default {
  sorry: 'Spiacenti',
  sorryClass: 'Spiacenti, non abbiamo trovato nessun ',
  weFound: 'non abbiamo trovato ',
  noResults: 'alcun risultato',
  fares: ' prezzo',
  theseDates: ' per queste date.',
  matchingSearch: 'che corrisponda alla tua ricerca.',
}
